module.exports = __webpack_public_path__ + "img/logowebcheckin.48a15878.svg";